import { CustomMultiFilterButton } from "../button/CustomMultiFilterButton";

export default function IssueTypeFilterButton({ currentValues, setValues }) {
    const values = [
        { label: "All Issue Type", value: "all" },
        { label: "Change Equipment", value: "Change Equipment" },
        { label: "Machine", value: "Machine" },
        { label: "Check symptoms", value: "Check symptoms" },
        { label: "Repair", value: "Repair" },
        { label: "Refund", value: "Refund" },
    ];

    return (
        <CustomMultiFilterButton
            icon={currentValues.includes("all") ? "alert_triangle_black" : "alert_triangle_active"}
            currentValues={currentValues}
            setValues={setValues}
            values={values}
            multiText={"Payment"}
            iconWidth={"13.5px"}
            iconHeight={"12px"}
        />
    );
}
